// @flow
import { combineReducers } from 'redux';

import * as common from './common';
import * as types from '../types/routes';
import type { ERROR_TYPE } from '../types/common';
import type {
  ROUTE_STOP_TYPE,
} from '../types/routes';

export type RouteStopsState = {
  byId: {[number]: ROUTE_STOP_TYPE},
  current: number,
  isEditing: boolean,
  fetchingStudents: Array<number>,
  fetching: Array<number>,
  errors: {[number]: ERROR_TYPE},
  assigningStops: boolean,
};


// TODO, CHANGE THE FOLLOWING FETCHED action,
const byId = common.byId({
  fetched: [types.ROUTE_STOPS_FETCH_SUCCEED],
  added: [types.ROUTE_STOP_ADDED],
  removed: [types.ROUTE_STOP_REMOVED, types.DELETE_ROUTE_STOP_STUDENT_SUCCESS],
  cascade: {
    [types.ROUTE_REMOVED]: 'route',
  },
  updated: [types.ROUTE_STOP_UPDATED, types.UPDATE_STOP_WEEKDAYS, types.ROUTE_STOP_FETCH_SUCCEED],
  confirmed: [types.ROUTE_STOP_CONFIRMED],
  defaultAttributes: {
    isConfirmed: false,
  },
});

const current = common.mux({
  selected: [types.ROUTE_STOP_SELECTED],
  allDeselected: [types.ROUTE_STOPS_DESELECTED],
  default: -1,
});

const fetchingStudents = common.fetching({
  started: [types.ROUTE_STOP_STUDENTS_FETCH_STARTED],
  succeed: [types.ROUTE_STOP_STUDENTS_FETCH_SUCCEED],
  failed: [types.ROUTE_STOP_STUDENTS_FETCH_FAILED],
});

const fetching = common.fetching({
  started: [types.ROUTE_STOP_FETCH_STARTED],
  succeed: [types.ROUTE_STOP_FETCH_SUCCEED],
  failed: [types.ROUTE_STOP_FETCH_FAILED],
});

const errors = common.errors({
  populate: [types.ROUTE_STOP_STUDENTS_FETCH_FAILED],
  clear: [
    types.ROUTE_STOP_STUDENTS_FETCH_SUCCEED,
    types.ROUTE_STOP_STUDENTS_FETCH_STARTED,
  ],
});

const isEditing = common.isFetching({
  started: [types.ROUTE_STOP_UPDATED],
  succeed: [types.ROUTE_STOP_FETCH_SUCCEED],
  failed: [types.ROUTE_STOP_FETCH_FAILED],
});

const assigningStops = common.toggle({
  turnedOn: [
    types.ROUTE_STOPS_STUDENT_ASSIGN_STARTED,
  ],
  turnedOff: [
    types.ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED,
    types.ROUTE_STOPS_STUDENT_ASSIGN_FAILED,
  ],
  default: false,
});

const routeStops = combineReducers({
  byId,
  current,
  fetchingStudents,
  errors,
  isEditing,
  fetching,
  assigningStops,
});

export default routeStops;

export const getRouteStop = (state: RouteStopsState, id: number): ROUTE_STOP_TYPE => state.byId[id];
export const getRouteStopIsEditing = (state: RouteStopsState): boolean => state.isEditing;
export const getCurrentRouteStopId = (state: RouteStopsState): number => state.current;
export const getCurrentRouteStop = (
  state: RouteStopsState,
): ROUTE_STOP_TYPE => getRouteStop(state, state.current);
export const isRouteStopFetchingStudents = (
  state: RouteStopsState,
  id: number,
): boolean => state.fetchingStudents.includes(id);
export const isRouteStopFetching = (
  state: RouteStopsState,
  id: number,
): boolean => state.fetching.includes(id);
export const getRouteStopError = (
  state: RouteStopsState,
  id: number,
): ERROR_TYPE => state.errors[id];
export const isAssigningStops = (state: RoutesState): boolean => state.assigningStops;



// WEBPACK FOOTER //
// ./src/scripts/reducers/routeStops.js